// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"2856861d","353":"a8257c0a","365":"b79c69a8","381":"e9541b26","528":"7a49fc27","720":"0d6783b6","816":"03c3a137","964":"53d98e51"}[chunkId] + ".chunk.js";
};